import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { LuSquareArrowRight } from 'react-icons/lu';
import { useUser } from './UserContext';
import { openConsentBanner } from './ConsentBanner';

const Header = () => {
	const [menuOpen, setMenuOpen] = useState(false);
	const { isLoggedIn, logout } = useUser();
	const navigate = useNavigate();

	const toggleMenu = () => setMenuOpen(!menuOpen);

	const handleManageConsentClick = () => {
		setMenuOpen(false);
		openConsentBanner();
	};

	const handleLogoutClick = () => {
		logout();
		setMenuOpen(false);
		navigate('/');
	};

	return (
		<header
			style={{
				backgroundImage: 'url("https://cdn.prod.website-files.com/650dc6e8c3edc32394341ca0/667e7109654405b4e76c8a47_fdghj.png")',
				backgroundSize: 'cover',
				backgroundRepeat: 'no-repeat',
				backgroundPosition: 'center center',
			}}
			className="bg-white shadow-md rounded-xl fixed top-0 left-0 right-0 z-50 w-[80%] mx-auto mt-4 p-2 flex items-center justify-between"
		>
			<div
				className="flex items-center cursor-pointer"
				onClick={() => navigate('/')}
			>
				<img
					src="https://cdn.prod.website-files.com/650dc6e8c3edc32394341ca0/667eb451fff66f1f375e0d73_Group%20772542619.png"
					alt="Logo"
					className="h-auto w-[140px]"
					loading="lazy"
				/>
			</div>

			<nav className="hidden md:flex items-center space-x-6">
				<ul className="flex space-x-6 text-lg font-medium">
					<li>
						<Link
							to="/"
							className="text-black hover:text-blue-600"
						>
							Products
						</Link>
					</li>
					<li>
						<Link
							to="/"
							className="text-black hover:text-blue-600"
						>
							Solutions
						</Link>
					</li>
					<li>
						<Link
							to="/"
							className="text-black hover:text-blue-600"
						>
							Resources
						</Link>
					</li>
					<li>
						<Link
							to="/"
							className="text-black hover:text-blue-600"
						>
							About Us
						</Link>
					</li>
					<li>
						<Link
							to="/verify-consent"
							className="text-black hover:text-blue-600"
						>
							Verify Consent
						</Link>
					</li>
					{isLoggedIn && (
						<li>
							<Link
								to="/privacy"
								className="text-black hover:text-blue-600"
							>
								Privacy
							</Link>
						</li>
					)}
				</ul>

				<div className="flex space-x-4">
					{isLoggedIn && (
						<button
							className="flex items-center border border-blue-500 text-blue-600 px-4 py-2 rounded-lg hover:bg-blue-50 transition"
							onClick={handleManageConsentClick}
						>
							Manage Consent
						</button>
					)}
					{isLoggedIn ? (
						<button
							className="flex items-center bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition"
							onClick={handleLogoutClick}
						>
							Logout
						</button>
					) : (
						<button
							className="flex items-center bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition"
							onClick={() => {
								setMenuOpen(false);
								navigate('/login');
							}}
						>
							<LuSquareArrowRight className="mr-2" /> Login
						</button>
					)}
				</div>
			</nav>

			<div className="md:hidden flex items-center">
				<button
					onClick={toggleMenu}
					className="text-black hover:text-blue-600 focus:outline-none"
				>
					<svg
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						viewBox="0 0 24 24"
						stroke="currentColor"
						className="w-6 h-6"
					>
						<path
							strokeLinecap="round"
							strokeLinejoin="round"
							strokeWidth="2"
							d="M4 6h16M4 12h16M4 18h16"
						/>
					</svg>
				</button>
			</div>
			{/* small screen */}
			{menuOpen && (
				<div className="absolute top-16 left-0 w-full bg-white shadow-md z-40 p-4 md:hidden">
					<ul className="space-y-4">
						<li>
							<Link
								to="/"
								className="block text-black hover:text-blue-600"
								onClick={() => setMenuOpen(false)}
							>
								Products
							</Link>
						</li>
						<li>
							<Link
								to="/"
								className="block text-black hover:text-blue-600"
								onClick={() => setMenuOpen(false)}
							>
								Solutions
							</Link>
						</li>
						<li>
							<Link
								to="/"
								className="block text-black hover:text-blue-600"
								onClick={() => setMenuOpen(false)}
							>
								Resources
							</Link>
						</li>
						<li>
							<Link
								to="/"
								className="block text-black hover:text-blue-600"
								onClick={() => setMenuOpen(false)}
							>
								About Us
							</Link>
						</li>
						{isLoggedIn && (
							<li>
								<Link
									to="/privacy"
									className="block text-black hover:text-blue-600"
									onClick={() => setMenuOpen(false)}
								>
									Privacy
								</Link>
							</li>
						)}
						{isLoggedIn && (
							<li>
								<button
									className="block w-full text-left border border-blue-500 text-blue-600 px-4 py-2 rounded-lg hover:bg-blue-50 transition"
									onClick={handleManageConsentClick}
								>
									Manage Consent
								</button>
							</li>
						)}
						<li>
							{isLoggedIn ? (
								<button
									className="block w-full text-left bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition"
									onClick={handleLogoutClick}
								>
									Logout
								</button>
							) : (
								<button
									className="block w-full text-left bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-600 transition"
									onClick={() => {
										setMenuOpen(false);
										navigate('/login');
									}}
								>
									Login
								</button>
							)}
						</li>
					</ul>
				</div>
			)}
		</header>
	);
};

export default Header;
